import CommonHelmet from '@src/components/CommonHelmet';
import SendResetPasswordEmailForm from '@src/features/company/auth/SendResetPasswordEmailForm';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';

function CompanySendResetPasswordEmail() {
  return (
    <>
      <CompanyCenterCardLayout>
        <CommonHelmet />
        <SendResetPasswordEmailForm />
      </CompanyCenterCardLayout>
    </>
  );
}

export default CompanySendResetPasswordEmail;
